<template>
  <div class="invitees-screen">
    <aside class="sidebar">
      <h2 class="sidebar-title">{{ eventTitle }}</h2>
      <ul class="nav-menu">
        <li @click="navigateTo('Dashboard')" class="nav-item">Dashboard</li>
        <li @click="navigateTo('Invitees')" class="nav-item active">Invitees</li>
        <li @click="navigateTo('Donations')" class="nav-item">Donations</li>
        <li @click="logout" class="nav-item logout">Logout</li>
      </ul>
    </aside>

    <main class="main-content">
      <h1 class="main-title">Gala Dinner</h1>

      <div class="action-buttons">
        <button class="btn" @click="addInvitee">Add Invitee</button>
      </div>

      <input
        type="text"
        v-model="searchQuery"
        placeholder="Search by name"
        class="search-box"
      />

      <div class="invitees-list">
        <div class="invitee-row invitee-header">
          <span>Name</span>
          <span>Status</span>
          <span>Table Number</span>
          <span>Amount Donated</span>
        </div>

        <div
          v-for="invitee in filteredInvitees"
          :key="invitee.id"
          class="invitee-row"
          @click="openPopup(invitee)"
        >
          <span>{{ invitee.firstName }} {{ invitee.lastName }}</span>
          <span>{{ invitee.status }}</span>
          <span>{{ invitee.tableNumber }}</span>
          <span :class="{'highlighted': invitee.donated > 0}">${{ invitee.donated }}</span>
        </div>
      </div>
      
      <!-- Popup for Invitee Details -->
      <InviteePopup
        v-if="selectedInvitee"
        :invitee="selectedInvitee"
        :isVisible="isPopupVisible"
        @update="updateInvitee"
        @close="closePopup"
      />
    </main>
  </div>
</template>

<script>
import InviteePopup from "./InviteePopup.vue";

export default {
  components: { InviteePopup },
  data() {
    return {
      eventTitle: "Gala Dinner",
      searchQuery: "",
      invitees: [
        {
          id: 1,
          firstName: "John",
          lastName: "Doe",
          status: "Pending",
          tableNumber: 1,
          donated: 100,
        },
        {
          id: 2,
          firstName: "Jane",
          lastName: "Smith",
          status: "Approved",
          tableNumber: 2,
          donated: 0,
        },
      ],
      selectedInvitee: null,
      isPopupVisible: false,
    };
  },
  computed: {
    filteredInvitees() {
      return this.invitees.filter((invitee) =>
        (invitee.firstName + " " + invitee.lastName)
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    navigateTo(page) {
      this.$router.push({ name: page });
    },
    logout() {
      this.$router.push({ name: "Login" }); // Navigate to login screen on logout
    },
    addInvitee() {
      const newInvitee = {
        id: Date.now(),
        firstName: "New",
        lastName: "Invitee",
        status: "Pending",
        tableNumber: null,
        donated: 0,
      };
      this.invitees.push(newInvitee);
    },
    openPopup(invitee) {
      this.selectedInvitee = { ...invitee };
      this.isPopupVisible = true;
    },
    updateInvitee(updatedInvitee) {
      const index = this.invitees.findIndex((inv) => inv.id === updatedInvitee.id);
      if (index !== -1) {
        this.invitees.splice(index, 1, updatedInvitee);
      }
      this.closePopup();
    },
    closePopup() {
      this.isPopupVisible = false;
      this.selectedInvitee = null;
    },
  },
};
</script>

<style scoped>
.invitees-screen {
  display: flex;
  /*background-color: #001643;*/
  color: white;
  height: 100vh;
}

.sidebar {
  width: 250px;
  /*background-color: #001643;*/    
  padding: 1rem;
}

.sidebar-title {
  color: #ff6b35;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.nav-menu {
  list-style: none;
  padding: 0;
}

.nav-item {
  cursor: pointer;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  font-size: 1.1rem;
  color: #00cfff;
}

.nav-item.active {
  font-weight: bold;
}

.main-content {
  flex: 1;
  padding: 2rem;
}

.logout {
  color: #ff6b35;
  font-weight: bold;
}

.main-title {
  color: #ff6b35;
  font-size: 2rem;
}

.action-buttons {
  margin-bottom: 1rem;
}

.btn {
  background-color: #00cfff;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
}

.search-box {
  padding: 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
  font-size: 1rem;
}

.invitees-list {
  display: flex;
  flex-direction: column;
}

.invitee-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #003366;
  cursor: pointer;
}

.invitee-header {
  font-weight: bold;
}

.highlighted {
  color: #00cfff;
}
</style>
